module.exports = __webpack_public_path__ + "static/assets/8839be7b633277383aa23cd1e44c4e64.svg";